module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n\r\n.form-control{\r\n    width: 180px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/property/property-form/property-form.component.css
// module id = ./src/app/recovery/property/property-form/property-form.component.css
// module chunks = main